module.exports = __webpack_public_path__ + "img/aperture.2a8578ce.svg";